import { render } from "./SpaceFlight.vue?vue&type=template&id=c890f102"
import script from "./SpaceFlight.vue?vue&type=script&lang=js"
export * from "./SpaceFlight.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__